// extracted by mini-css-extract-plugin
export default {"buttonGroup":"Overlay_buttonGroup__Zk3uT","modalButton":"Overlay_modalButton__tDluK","modalContent":"Overlay_modalContent__60MrU"};